import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";
const IMPERSONATION_STORAGE_KEY = "pb.userImpersonation.v1";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
    const raw = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (raw) {
      const imp = JSON.parse(raw);
      if (imp?.email) {
        h["X-PB-Impersonate-Email"] = String(imp.email).trim().toLowerCase();
      }
      if (imp?.userTypeId) {
        h["X-PB-Impersonate-User-Type-Id"] = String(imp.userTypeId).trim();
      }
    }
  } catch {
    /* ignore */
  }
  return h;
}

/**
 * @param {{ message: string, history?: { role: 'user'|'assistant', content: string }[] }} payload
 */
export async function postPortfolioAiChat(payload) {
  const { data } = await axios.post(`${getApiBase()}/ai/portfolio-chat`, payload, {
    headers: authHeaders(),
    timeout: 120000,
  });
  return data;
}
